<template>
    <div class="underLogoPhrase">
        <h2 class="font-weight-bold mb-4 centers">Les Animaux</h2>
        <p class="littlesize">
      
            Dernières mises à jour :
            <br>
             <span v-if="lastUpdateChien">chien : {{ new Date(lastUpdateChien).toLocaleString() }}</span>
  <span v-if="lastUpdateChat"> <br> chat : {{ new Date(lastUpdateChat).toLocaleString() }}</span>
        </p>

    </div>

    <div class="container-fluid">
        <div class="row responsive">
            <button class="bluenow buttonadaptatif responsive aniaml" @click="filtrerAnimaux('all')">Tous</button>
            <button class="bluenow buttonadaptatif responsive aniaml" @click="filtrerAnimaux('chien')">Chiens</button>
            <button class="bluenow buttonadaptatif responsive aniaml" @click="filtrerAnimaux('chat')">Chats</button>
        </div>

        <div class="row">
            <div class="col-lg-4" v-for="animau in animauxFiltres" :key="animau.id">
                <router-link :to="'/animaux/' + animau.id" class="card" style="height: auto; min-height: 350px;">
                    <div>
                        <img :src="'https://admin.asso-refuge.fr/images/' + animau.img1"
                            :alt="'photo du ' + animau.type + ' ' + animau.name" :class="'tailleimg'"
                            :title="animau.name + ' ' + animau.race" />
                    </div>
                    <div class="endessous" style="margin-top: 10px !important;margin-bottom: 30px;">
                        <h4 class="namedogtitleback">{{ animau.name }}</h4>
                        <h6>{{ animau.race }}</h6>
                        <h6><strong> Age: {{ calculateAge(animau.naissance) }}</strong></h6>
                        <h6 style="color:red">{{ animau.huge_information }}</h6>
                        <i class="fas fa-plus-circle"></i>
                    </div>
                </router-link>
            </div>
        </div>
    </div>

</template>


<script>
import convertAge from '../components/getAge.js';

export default {
  data() {
    return {
      animaux: [],
      animauxFiltres: [],
      lastUpdateChien: null,
      lastUpdateChat: null
    };
  },
  mounted() {
    const idSite = this.$idSite;
    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        this.animaux = data;
        this.appliquerFiltre();
        this.calculerDernieresMAJ(); // ← méthode ajoutée
      })
      .catch(error => {
        console.error('Il y a eu un problème avec votre requête :', error.message);
      });
  },
  methods: {
    appliquerFiltre() {
      const type = this.$route.query.type || 'all';
      this.animauxFiltres = type === 'all'
        ? this.animaux
        : this.animaux.filter(animal => animal.type === type);
    },
    filtrerAnimaux(type) {
      this.$router.push({ path: this.$route.path, query: { type } });
    },
    calculateAge(dateOfBirth) {
      return convertAge(dateOfBirth);
    },
    calculerDernieresMAJ() {
      const chiens = this.animaux.filter(a => a.type === 'chien');
      const chats = this.animaux.filter(a => a.type === 'chat');

      const maxDate = array =>
        array.reduce((latest, current) =>
          new Date(current.created_at) > new Date(latest.created_at) ? current : latest,
        array[0]);

      this.lastUpdateChien = chiens.length ? maxDate(chiens).created_at : null;
      this.lastUpdateChat = chats.length ? maxDate(chats).created_at : null;
    }
  },
  watch: {
    '$route.query.type': 'appliquerFiltre'
  }
};
</script>
